import React from "react";

const font = '"DM Sans", sans-serif';

function TableCell({ children, bold, style = {}, onClick }) {
  return (
    <td
      onClick={onClick}
      style={{
        padding: "12px 14px",
        fontSize: 14,
        color: bold ? "#363636" : "#5a5a5a",
        fontWeight: bold ? 600 : 400,
        fontFamily: font,
        borderBottom: "1px solid rgba(0,0,0,0.04)",
        ...style,
      }}
    >
      {children}
    </td>
  );
}

export default TableCell;
